export const state = {
  item: {},
  items: {},
  questions: null
}
